import React from 'react';
import { Shield, AlertTriangle, Briefcase, Users, Calendar } from 'lucide-react';
export function HeroSection() {
  return <>
      <section className="relative min-h-[62vh] flex items-center border-b border-brand-gray-800 overflow-hidden" data-id="element-581">
        <img src="https://cdn.magicpatterns.com/uploads/v77DWtd34BHMkiBGhUguAb/herobg3.jpg" alt="" className="block absolute inset-0 w-full h-full object-cover" data-id="element-582" />
        <div className="absolute inset-0 bg-brand-black/85 z-[1]" data-id="element-583" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full py-[4.5rem]" data-id="element-584">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-585">
            <div data-id="element-586">
              <div className="inline-flex items-center gap-2 px-3 py-1 border border-brand-teal/30 bg-brand-teal/10 text-brand-teal text-xs font-bold uppercase tracking-widest mb-8 clip-edges" data-id="element-587">
                <span className="w-2 h-2 bg-brand-teal animate-pulse" data-id="element-588" />
                Be The Standard
              </div>

              <h1 className="text-5xl md:text-7xl font-extrabold text-brand-white tracking-tight leading-[1.05] mb-6 uppercase" data-id="element-589">
                Medina Tactical{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-teal to-brand-teal-light" data-id="element-590">
                  Dynamics
                </span>
              </h1>

              <p className="text-xl text-brand-gray-300 mb-8 max-w-xl font-light border-l-2 border-brand-teal pl-6 leading-relaxed" data-id="element-591">
                Training, consulting, and preparedness planning with{' '}
                <strong className="text-brand-white font-semibold" data-id="element-592">
                  360° situational awareness
                </strong>{' '}
                — serving law enforcement, corporate, and civilian needs.
              </p>

              <div className="flex flex-col sm:flex-row gap-4" data-id="element-593">
                <a href="/training" className="inline-flex items-center justify-center font-semibold uppercase tracking-wider transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black active:scale-[0.97] active:transition-none clip-edges bg-brand-teal text-brand-white border border-transparent hover:bg-brand-teal-light px-8 py-4 text-base gap-2.5 group" data-id="element-594">
                  <Calendar className="w-5 h-5" data-id="element-595" />
                  View Calendar
                </a>
                <a href="/contact" className="inline-flex items-center justify-center font-semibold uppercase tracking-wider transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black active:scale-[0.97] active:transition-none clip-edges bg-transparent text-brand-teal border border-brand-teal hover:bg-brand-teal hover:text-brand-white px-8 py-4 text-base gap-2.5" data-id="element-596">
                  Contact Us
                </a>
              </div>
            </div>

            <div className="hidden lg:block" data-id="element-597">
              <div className="border border-brand-gray-800 bg-brand-black/60 p-8 backdrop-blur-sm" data-id="element-598">
                <div className="w-8 h-0.5 bg-brand-teal mb-6" data-id="element-599" />
                <h3 className="text-lg font-bold text-brand-white uppercase tracking-wide mb-6" data-id="element-600">
                  What We Do
                </h3>
                <ul className="space-y-5" data-id="element-601">
                  {[{
                  icon: Shield,
                  title: 'Law Enforcement Training',
                  desc: 'Specialized training and consulting for law enforcement professionals'
                }, {
                  icon: AlertTriangle,
                  title: 'Crisis Planning',
                  desc: 'Preparation and strategic planning for crisis situations'
                }, {
                  icon: Briefcase,
                  title: 'Corporate Strategies',
                  desc: 'Corporate planning and strategies for critical incidents'
                }, {
                  icon: Users,
                  title: 'Civilian Protection',
                  desc: 'Consulting for civilian entities'
                }].map(item => <li key={item.title} className="flex items-start gap-4" data-id="element-602">
                      <item.icon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-603" />
                      <div data-id="element-604">
                        <p className="text-sm font-semibold text-brand-white uppercase tracking-wide" data-id="element-605">
                          {item.title}
                        </p>
                        <p className="text-xs text-brand-gray-400 mt-1 leading-relaxed" data-id="element-606">
                          {item.desc}
                        </p>
                      </div>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}